import { useSelector } from 'react-redux'
import { selectVehicles } from '@/features/domain/vehicle'

export function useVehicles() {
  return useSelector(selectVehicles)
}
